// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "misc-vendors" + "." + "68f8b116a5799aedaecd" + ".css";
};